import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import createApiCall, { apiURL } from '../../apis/wpApi/endpoints'
import authUser from '../../apis/wpApi/authUser'
import { OVERLAY_SPINNER } from '../../constants/overlayTypes'
import getData from '../../functions/getData'
import { PROGRAM_MOVIEMAPPING_ITEMS, PROGRAM_PM_MOVIES_ITEMS } from '../../constants/state'
import { updateProgram } from '../programSaga/helpers'

const pmMoviePkSelector = (state, metaMoviePk) => getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, metaMoviePk, 'pm'])
const pmMovieItemSelector = (state, pmMoviePk) => getData(state, [PROGRAM_PM_MOVIES_ITEMS, pmMoviePk])

function* refetchProgram() {
    yield put({ type: actionTypes.PROGRAM_GET_REQUEST, payload: { signal: false } })
    yield take([actionTypes.PROGRAM_GET_SUCCESS, actionTypes.PROGRAM_GET_ERROR])
}

function* applyKeptTitle(destinationMetaMoviePk, keptTitle) {
    const pmMoviePk = yield select(pmMoviePkSelector, destinationMetaMoviePk)
    if (!pmMoviePk) return

    const pmMovieItem = yield select(pmMovieItemSelector, pmMoviePk)
    if (!pmMovieItem) return

    // The merge changes the display title only. Rebuilding the whole row for
    // the edit-form writer lost the start date (#113).
    yield put({
        type: actionTypes.PMMOVIES_UPDATE_ITEM_TITLE_DISPLAY,
        payload: { pk: pmMoviePk, titleDisplay: keptTitle },
    })
    yield call(updateProgram)
    yield take([actionTypes.PROGRAM_UPDATE_SUCCESS, actionTypes.PROGRAM_UPDATE_ERROR])
}

function* watchMetaMerge() {
    yield takeLatest(actionTypes.META_MERGE_REQUEST, function* ({ payload }) {
        try {
            const { sourceMetaMoviePk, destinationMetaMoviePk, keptTitle } = payload
            const token = authUser.getToken()
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: actionTypes.META_MERGE_REQUEST } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: { overlayType: OVERLAY_SPINNER } })
            yield call(createApiCall, {
                url: apiURL.META_MERGE,
                method: 'POST',
                data: { sourceMetaMoviePk, destinationMetaMoviePk },
                headerParams: { token },
            })
            yield put({
                type: actionTypes.META_MERGE_SUCCESS,
                payload: { sourceMetaMoviePk, destinationMetaMoviePk },
            })
            if (keptTitle) {
                yield call(applyKeptTitle, destinationMetaMoviePk, keptTitle)
            }
            yield call(refetchProgram)
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        } catch (e) {
            yield put({ type: actionTypes.META_MERGE_FAILURE, payload: { error: e.message } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        }
    })
}

function* watchMetaMove() {
    yield takeLatest(actionTypes.META_MOVE_REQUEST, function* ({ payload }) {
        try {
            const { providerMovieKey, providerMovieUuid, sourceMetaMoviePk, destinationMetaMoviePk } = payload
            const token = authUser.getToken()
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: actionTypes.META_MOVE_REQUEST } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: { overlayType: OVERLAY_SPINNER } })
            yield call(createApiCall, {
                url: apiURL.META_MOVE,
                method: 'POST',
                data: {
                    providerMovie: { [providerMovieKey]: providerMovieUuid },
                    destinationMetaMoviePk,
                },
                headerParams: { token },
            })
            yield put({
                type: actionTypes.META_MOVE_SUCCESS,
                payload: { providerMovieKey, providerMovieUuid, sourceMetaMoviePk, destinationMetaMoviePk },
            })
            yield call(refetchProgram)
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        } catch (e) {
            yield put({ type: actionTypes.META_MOVE_FAILURE, payload: { error: e.message } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        }
    })
}

function* watchMetaSplit() {
    yield takeLatest(actionTypes.META_SPLIT_REQUEST, function* ({ payload }) {
        try {
            const { providerMovieKey, providerMovieUuid, sourceMetaMoviePk } = payload
            const token = authUser.getToken()
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE, payload: { requestType: actionTypes.META_SPLIT_REQUEST } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE, payload: { overlayType: OVERLAY_SPINNER } })
            const response = yield call(createApiCall, {
                url: apiURL.META_SPLIT,
                method: 'POST',
                data: { providerMovie: { [providerMovieKey]: providerMovieUuid } },
                headerParams: { token },
            })
            yield put({
                type: actionTypes.META_SPLIT_SUCCESS,
                payload: {
                    providerMovieKey,
                    providerMovieUuid,
                    sourceMetaMoviePk,
                    newMapping: response.data.mapping,
                },
            })
            yield call(refetchProgram)
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        } catch (e) {
            yield put({ type: actionTypes.META_SPLIT_FAILURE, payload: { error: e.message } })
            yield put({ type: actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET })
        }
    })
}

export default function* metaMappingSaga() {
    yield all([
        watchMetaMerge(),
        watchMetaMove(),
        watchMetaSplit(),
    ])
}
